import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';

import { PaginationTableOffersType } from '../types/MovimentacaoFundosType';
import { renderButtons } from '../utils/renderButtons';

type PaginationTableOffersProps = {
  dataPagination: PaginationTableOffersType;
};

export const PaginationTableOffers = ({
  dataPagination
}: PaginationTableOffersProps) => {
  const offset = dataPagination.propsRows.offset
    ? dataPagination.propsRows.offset
    : 0;
  const limit = dataPagination.propsRows.limit
    ? dataPagination.propsRows.limit
    : 0;
  const total = dataPagination.propsRows.total
    ? dataPagination.propsRows.total
    : 0;

  return (
    <div className="tw-full tw-mt-5 tw-flex tw-justify-end tw-items-center tw-gap-10">
      <p className="tw-text-1.5xl  tw-text-blue-900">
        {`Exibindo de  ${offset + 1} até  ${
          limit + offset <= total ? limit + offset : total
        } de ${total}`}
      </p>
      <div className="flex gap-2">
        <button
          data-testid="previous-button"
          className={
            dataPagination.currentPage <= 1
              ? 'tw-w-10 tw-bg-transparent tw-text-1.5xl tw-text-gray-300'
              : 'tw-w-10 tw-bg-transparent tw-text-1.5xl tw-text-blue-900'
          }
          onClick={() => {
            const currentPage =
              dataPagination.currentPage <= 1
                ? 1
                : dataPagination.currentPage - 1;
            dataPagination.handlePageClick(currentPage);
          }}
        >
          <ChevronLeftIcon className="tw-w-6 tw-h-6" />
        </button>
        {renderButtons(dataPagination)}
        <button
          data-testid="next-button"
          className={
            dataPagination.currentPage >= dataPagination.totalPages
              ? 'tw-w-10 tw-bg-transparent tw-text-1.5xl tw-text-gray-300'
              : 'tw-w-10 tw-bg-transparent tw-text-1.5xl tw-text-blue-900'
          }
          onClick={() => {
            const y =
              dataPagination.currentPage >= dataPagination.totalPages
                ? dataPagination.totalPages
                : dataPagination.currentPage + 1;
            dataPagination.handlePageClick(y);
          }}
        >
          <ChevronRightIcon className="tw-w-6 tw-h-6" />
        </button>
      </div>
    </div>
  );
};
